export const shelfTypeConfig = {
  YILAI_TYPE_NAME: "Yilai",
  SHEKEL_TYPE_NAME: "Shekel",
  DIGITSHELF_TYPE_NAME: "DigitShelf",
  XSHELF_TYPE_NAME: "XShelf",
}

export const gondolaTypeConfig = [
  "Gondola",
  "Cooler",
  "Smart Cooler - Single Door",
  "Smart Cooler - Double Cooler",
]
